<?xml version="1.0" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"
        "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
     width="16.000000pt" height="16.000000pt" viewBox="0 0 16.000000 16.000000"
     preserveAspectRatio="xMidYMid meet">

    <g transform="translate(0.000000,16.000000) scale(0.100000,-0.100000)"
       fill="#000000" stroke="none">
        <path d="M10 80 l0 -70 70 0 70 0 0 70 0 70 -70 0 -70 0 0 -70z m110 0 l0 -40
-40 0 -40 0 0 40 0 40 40 0 40 0 0 -40z"/>
    </g>
</svg>
